export default "__VITE_ASSET__36bcb053__"